module.exports = __webpack_public_path__ + "static/assets/aron_profile.fb24fd3f.jpg";